var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import MuiButton, { buttonClasses } from '@mui/material/Button';
import { Spinner } from '../spinner';
import { styled } from '../styled';
export var buttonComponentName = 'QuantumButton';
export { buttonClasses };
var Root = styled(MuiButton, {
    name: buttonComponentName,
    slot: 'Root',
})(function (_a) {
    var _b;
    var ownerState = _a.ownerState;
    if (ownerState.isLoading) {
        return _b = {
                color: 'transparent'
            },
            _b["&.".concat(buttonClasses.disabled, ",&:disabled")] = {
                color: 'transparent',
            },
            _b;
    }
    return {};
});
var ButtonSpinner = styled(Spinner, {
    name: buttonComponentName,
    slot: 'Spinner',
})({
    position: 'absolute',
});
export var Button = React.forwardRef(function (_a, ref) {
    var isLoading = _a.isLoading, label = _a.label, children = _a.children, disabled = _a.disabled, _b = _a.SpinnerProps, SpinnerProps = _b === void 0 ? {} : _b, _c = _a.color, color = _c === void 0 ? 'default' : _c, variant = _a.variant, rootProps = __rest(_a, ["isLoading", "label", "children", "disabled", "SpinnerProps", "color", "variant"]);
    return (React.createElement(Root, __assign({}, rootProps, { disabled: disabled || isLoading, ownerState: { isLoading: isLoading }, color: color, variant: variant, ref: ref }),
        label || children,
        " ",
        !!isLoading && React.createElement(ButtonSpinner, __assign({}, SpinnerProps))));
});
